export default "__VITE_ASSET__Chybn9$V__"